<template>
  <v-container>
    <v-card>
      <v-container>
        <v-card-title>
          <v-text-field v-model="search" label="従業員コード検索" single-line hide-details></v-text-field>
          
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="stores"
          :search="search"
          hide-actions
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.userId }}</td>
              <td>{{ props.item.positionCode }}</td>
              <td>{{ props.item.storeCode }}</td>
              <td>
                <div class="store-name-text">
                  {{ props.item.storeName }}
                </div>
              </td>              
              <td>{{ props.item.prefectureName }}</td>              
              <td class="text-xs-left">{{ formatDate(props.item.createdAt) }}</td>              
              <td class="text-xs-center">
                <v-btn
                  icon
                  small
                  aria-label="削除"
                  @click="deleteOcrUserStoreMapping(props.item)"
                >
                  <v-icon small color="error">delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
            >検索キーワード["{{ search }}]に該当する店舗は存在しません</v-alert>
          </template>
        </v-data-table>
        <br />
      </v-container>
    </v-card>

    <br />
    <v-layout row wrap class="button-area">
      <v-flex xs12 sm6 class="button-left">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
      </v-flex>

      <v-flex xs12 sm6 class="button-right">
        <v-btn block color="success" dark :to="{ name: 'admin/ocr-user-store-mapping/new' }">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {

    ServerApiCallService.ocrUserStoreMapping()
      .then(response => {
        this.stores = response.data.ocrUserStoreMapping
      })
      .catch(error => {
        console.log('There was an error: ocrUserStoreMapping, ', error.response)
      })
  },
  methods: {
    getAppComponent() {
      return this.$parent.$parent.$parent
    },

    deleteOcrUserStoreMapping(item) {
      
      const confirmed = window.confirm(
        `ユーザーID「${item.userId}」の権限情報を削除しますか？`
      )

      if (!confirmed) return

      const request = {
        userId: item.userId,
        positionCode: item.positionCode,
        prefectureCode:
          item.prefectureCode !== null &&
          item.prefectureCode !== undefined
            ? item.prefectureCode
            : null,
        storeCode: item.storeCode || null
      }
      
      const sendContext = {
        hasDialogComponent: this.getAppComponent(),
        forwardNameOnClose: 'admin/ocr-user-store-mapping'
      }

      ServerApiCallService.ocrUserStoreDelete(request, sendContext)
        .then(() => {
          // 삭제 조건과 일치하는 행을 화면에서도 제거
          this.stores = this.stores.filter(store =>
            !(
              store.userId === item.userId &&
              store.positionCode === item.positionCode &&
              store.prefectureCode === item.prefectureCode &&
              store.storeCode === item.storeCode
            )
          )
        })
        .catch(error => {
          console.error(
            'There was an error: deleteOcrUserStoreMapping, ',
            error.response
          )
        })
    },

    formatDate(value) {
      if (!value) return ''

      return value.substring(0, 16)
    }
  },
  data() {
    return {
      search: '',

      headers: [
        { text: 'userId', value: 'userId' },
        { text: 'Position', value: 'positionCode' },
        { text: '店舗コード', value: 'storeCode'},
        { text: '店舗名', value: 'storeName', align: 'left' },
        { text: '地域名', value: 'prefectureName'},
        { text: '作成日', value: 'createdAt' },
        
        {
          text: '削除',
          value: 'delete',
          sortable: false,
          align: 'center'
        }
      ],
      stores: []
    }
  }
}
</script>

<style>
table.v-table thead th {
  font-size: 14px !important;  
  color: #333 !important;
}
.button-left {
  padding-right: 6px;
}

.button-right {
  padding-left: 6px;
}
.editable-row {
  cursor: pointer;
}

.editable-row:hover {
  background-color: #f5f7fa !important;
}

.store-name-text {
  width: 100%;
  text-align: left !important;
}

</style>
